<template>
  <div class="my_hover_btn lineControl" :title="tips" @click.stop.prevent="changeStyle">
    <span :class="btnIcon"  v-if="btnType == 'btn'"></span>
    <span v-if="btnType == 'text'" v-text="title"></span>
  </div>
</template>

<script>
export default {
  name: 'my_hover_btn',
  data() {
    return {
    };
  },
  props:{
    btnIcon:{
      type:String,
      default:''
    },
    btnType: {
      type:String,
      default:'btn'
    },
    title: {
      type:String,
      default:''
    },
    tips: {
      type:String,
      default:''
    }
  },
  methods:{
    changeStyle() {
      this.$emit('changeStyle')
    }
  }
};
</script>

<style lang="scss" scoped>
.my_hover_btn:hover {
  background-color: #2e343B;
}
</style>



// WEBPACK FOOTER //
// src/components/my_hover_btn/index.vue